import { Alert, AlertProps } from 'antd';
import React from 'react';
import { IconUtils } from '@/utils';

/**
 * antd renamed `Alert`'s heading prop from `message` to `title` in v6 and kept
 * the old one working, but warning on every render. Both are accepted here and
 * only `title` reaches antd, so the rename lives in this one file instead of at
 * every call site — which is what this wrapper is for.
 *
 * New code should pass `title`. `message` stays for the callers written against
 * the old API and is not something to reintroduce.
 */

export type AppAlertProps = Omit<AlertProps, 'icon' | 'message'> & {
  /** Optional icon override - if not provided, will use Font Awesome based on type */
  icon?: React.ReactNode;
  /** @deprecated antd v6 renamed this to `title`. Pass `title` instead. */
  message?: React.ReactNode;
};

const AppAlert: React.FC<AppAlertProps> = ({ type = 'info', icon, title, message, ...props }) => {
  const alertType = type as 'success' | 'info' | 'warning' | 'error';
  const displayIcon = icon ?? IconUtils.getIcon(alertType, true);

  return <Alert type={alertType} icon={displayIcon} title={title ?? message} {...props} />;
};

AppAlert.displayName = 'AppAlert';

export default AppAlert;
